import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Heart, PawPrint } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Daisy() {
  const { t } = useLanguage();
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [-16, 16]);
  return (
    <section id="daisy" ref={ref} data-testid="daisy-section" className="daisy-section">
      <motion.div className="daisy-photograph" style={{ y: reduced ? 0 : y }}>
        <img src="/images/daisy-1920.webp" srcSet="/images/daisy-960.webp 960w, /images/daisy-1920.webp 1920w, /images/daisy-3840.webp 3840w" sizes="100vw" width="1264" height="848" alt={t("refresh.daisyAlt")} data-testid="daisy-image" loading="lazy" decoding="async" />
      </motion.div>
      <div className="daisy-shade" aria-hidden="true" />
      <div className="studio-container daisy-inner">
        <div className="daisy-overline mono-label" data-testid="daisy-honourable-mention"><PawPrint size={18} />{t("founders.daisy.label")}<span>04 / THE HEART</span></div>
        <motion.div className="daisy-copy" initial={{ opacity: 0, y: reduced ? 0 : 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.2 }} transition={{ duration: 0.8 }}>
          <span className="daisy-role mono-label" data-testid="daisy-role">{t("refresh.daisyRole")}</span>
          <h2 className="sr-only">Daisy the Doggy</h2><p className="daisy-name" data-testid="daisy-name">Daisy<span>.</span></p>
          <p className="daisy-subtitle" data-testid="daisy-subtitle">{t("refresh.daisySubtitle")}</p>
          <p className="daisy-body" data-testid="daisy-description">{t("founders.daisy.body")}</p>
          <div className="daisy-breed" data-testid="daisy-breed"><Heart size={16} className="daisy-heart" />{t("refresh.breed")}</div>
        </motion.div>
        <p className="daisy-caption mono-label" data-testid="daisy-image-caption">{t("refresh.daisyCaption")}</p>
      </div>
    </section>
  );
}